import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import metrics from "@constants/metrics";
import RightArrow from "@assets/svg/RightArrow";
import { useSelector } from "react-redux";
import colors from "@constants/color";
import { scale } from "../../utils/scale";
import color from "../../constants/color";
import BackArrow from "../../assets/svg/BackArrow";
import AddContact from "../../assets/svg/AddContact";
import CustomText from "../CustomText";

export function Header(props) {
  const { is_suspended, leader_state } = useSelector(({ auth }) => auth.user);

  const {
    onBackClick,
    title,
    rightBtnClick,
    rightTitle,
    addContactPress,
    isBtn,
    testReferid = "",
  } = props || {};

  const btnDisabled = !!is_suspended || !!leader_state === "LEADER_SUSPENDED";

  return (
    <View style={styles.topNavContainer}>
      <View style={styles.topNav}>
        <TouchableOpacity onPress={onBackClick} style={styles.arrowCont}>
          <BackArrow />
        </TouchableOpacity>
        <CustomText
          variant="subtitle_16"
          bold
          fontType="head1"
          style={styles.textLeftPadding}
        >
          {title}
        </CustomText>

        {!!rightTitle && (
          <View
            testID={testReferid}
            style={{ alignItems: "center", flexDirection: "row" }}
          >
            <CustomText
              variant="subtitle_16"
              onPress={rightBtnClick}
              bold
              fontType="head1"
              style={styles.textRight}
            >
              {rightTitle}
            </CustomText>
            <RightArrow />
          </View>
        )}
        {isBtn ? (
          <TouchableOpacity
            onPress={addContactPress}
            disabled={btnDisabled}
            style={[
              styles.addContactStyle,
              btnDisabled ? { backgroundColor: colors.silver } : {},
            ]}
          >
            <AddContact />
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
}

export default Header;

const styles = StyleSheet.create({
  topNavContainer: {
    flexDirection: "row",
    paddingVertical: 18,
    paddingHorizontal: metrics.mainContainerPadding,
    backgroundColor: color.white,
    alignItems: "center",
    alignContent: "space-around",
    justifyContent: "space-between",
  },
  topNav: { flexDirection: "row", alignItems: "center" },
  textLeftPadding: {
    // width: "82%",
    flex: 1,
    paddingLeft: scale(30),
  },
  textRight: {
    color: "#E40046",
    marginRight: 8,
  },
  addContactStyle: {
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    height: scale(40),
    width: scale(40),
    borderRadius: scale(20),
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
});
